/* External */
import { combineReducers } from "redux";

/* Actions */
import { ACTION_TYPES_SET_ERROR } from "./actions.js";

/* Reducers */
import asset from "./asset/reducers";
import content from "./content/reducers";
import entitlementsToken from "./entitlementsToken/reducers";
import heartbeat from "./heartbeat/reducers";
import playSource from "./playSource/reducers";

const error = (defaultState = "", { type, payload }) => {
  switch (type) {
    case ACTION_TYPES_SET_ERROR:
      return payload;
    default:
      return defaultState;
  }
};

export default combineReducers({
  asset,
  content,
  entitlementsToken,
  error,
  playSource,
  heartbeat
});
